import { useEffect } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router';

import { LoadingProvider } from './app/providers/LoadingProvider.tsx';
import { ResponsiveProvider } from './app/providers/ResponsiveProvider.tsx';
import { SnackbarProvider } from './app/providers/SnackbarProvider.tsx';
import { store } from './app/store/store.ts';
import AppLifecycleBootstrap from './components/AppLifecycleBootstrap.tsx';
import { RouteErrorBoundary } from './components/common/RouteErrorBoundary.tsx';
import { AppRoutes } from './routes/AppRoutes.tsx';

export default function App() {
    useEffect(() => {
        // the app is mounted It is now safe to clear the reload chunk load flag for future deployments.
        if (sessionStorage.getItem('vite-preload-reloaded')) {
            sessionStorage.removeItem('vite-preload-reloaded');
        }
    }, []);

    return (
        <Provider store={store}>
            {/* TODO: TO BE REMOVE ONCE OLD UI NO LONGER VALID */}
            <ResponsiveProvider>
                <SnackbarProvider>
                    <LoadingProvider>
                        <BrowserRouter>
                            <AppLifecycleBootstrap />
                            <RouteErrorBoundary>
                                <AppRoutes />
                            </RouteErrorBoundary>
                        </BrowserRouter>
                    </LoadingProvider>
                </SnackbarProvider>
            </ResponsiveProvider>
        </Provider>
    );
}
